import gql from 'graphql-tag';






const getBrandPresets = gql`
  query GetBrandPresets(
    $organisationId: String!,
    $searchTerm: String,
    $isArchived: Boolean,
    $filter: BrandPresetsFilterInput,
    $updatedAfter: String
  ) {
    getBrandPresets(
      organisationId: $organisationId,
      searchTerm: $searchTerm
      isArchived: $isArchived,
      filter: $filter
      updatedAfter: $updatedAfter
    ) {
      brandPresetId,
      name,
      isDefault,
      proBrandingStatus,
      defaultLogo,
      thumbnail,
      createdByUserId,
      createdAt
    }
  }
`;

export default ((organisationId) => ({
  query: getBrandPresets,
  module: 'organisations',
  fetchPolicy: 'no-cache',
  buildVariables: (
  searchTerm,
  filter,
  isArchived,
  updatedAfter) => (
  {
    organisationId,
    searchTerm,
    isArchived,
    filter,
    updatedAfter
  })
}));